document.addEventListener("DOMContentLoaded", function () {
  const toggleInput = document.getElementById('product-toggle');
  const toggleContainer = document.getElementById('product-toggle-container');
  const item1Content = document.querySelector('.item1-content');
  const item2Content = document.querySelector('.item2-content');
  const item1FirstSection = document.querySelector('.item1-content .fum-product-feature-toggle-first-section');
  const item2FirstSection = document.querySelector('.item2-content .fum-product-feature-toggle-first-section');
  const wrapper = document.querySelector('.fum-product-feature-toggle-wrapper');

  // Keep a reference to the original parent and next sibling to restore on desktop
  const originalParent = toggleContainer ? toggleContainer.parentElement : null;
  const originalNextSibling = toggleContainer ? toggleContainer.nextElementSibling : null;

  const SECTION_SELECTORS = [
    // first section (heading cluster)
    '.fum-product-feature-toggle-first-section',
    // media section
    '.fum-product-feature-toggle-second-section',
    // third CTA/summary section
    '.fum-product-feature-toggle-third-section',
    // fourth: features grid and related elements
    '.fum-product-feature-toggle-fourth-title',
    '.fum-product-feature-toggle-fourth-section',
    '.fum-product-feature-toggle-fourth-button'
  ];

  function setHidden(nodeList, hidden) {
    if (!nodeList) return;
    nodeList.forEach(function(el) {
      if (!el) return;
      if (hidden) {
        el.classList.add('is-hidden');
      } else {
        el.classList.remove('is-hidden');
      }
    });
  }

  function toggleContent() {
    const item1Targets = item1Content ? item1Content.querySelectorAll(SECTION_SELECTORS.join(',')) : null;
    const item2Targets = item2Content ? item2Content.querySelectorAll(SECTION_SELECTORS.join(',')) : null;

    if (toggleInput.checked) {
      // Item 2 active
      setHidden(item1Targets, true);
      setHidden(item2Targets, false);
    } else {
      // Item 1 active
      setHidden(item1Targets, false);
      setHidden(item2Targets, true);
    }
    // Ensure placement reflects the active item on mobile
    placeToggleForViewport();
  }

  // Initial state
  toggleContent();

  // Add event listener
  toggleInput.addEventListener('change', toggleContent);

  function insertAfter(referenceNode, node) {
    if (!referenceNode || !referenceNode.parentNode) return;
    if (referenceNode.nextSibling) {
      referenceNode.parentNode.insertBefore(node, referenceNode.nextSibling);
    } else {
      referenceNode.parentNode.appendChild(node);
    }
  }

  function placeToggleForViewport() {
    const isMobile = window.matchMedia('(max-width: 1024px)').matches;
    if (!toggleContainer) return;

    if (isMobile) {
      const isItem2Active = !!toggleInput.checked;
      const targetFirstSection = isItem2Active ? item2FirstSection : item1FirstSection;
      if (targetFirstSection) {
        insertAfter(targetFirstSection, toggleContainer);
      }
    } else if (originalParent) {
      // Restore original position for desktop
      if (originalNextSibling) {
        originalParent.insertBefore(toggleContainer, originalNextSibling);
      } else {
        originalParent.appendChild(toggleContainer);
      }
    }
  }

  placeToggleForViewport();
  window.addEventListener('resize', placeToggleForViewport);
}); 